"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ValueType = exports.OptionType = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Throbber = _interopRequireDefault(require("../../../Throbber"));
var _excluded = ["data", "isDisabled"],
  _excluded2 = ["options", "value", "onChange", "onInputChange", "isMulti", "isDisabled", "isLoading", "isCreatable", "isBordered"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MenuList = function MenuList(props) {
  var children = props.children;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.MenuList, props, children);
};
var Option = function Option(_ref) {
  var data = _ref.data,
    isDisabled = _ref.isDisabled,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var __isNew__ = data.__isNew__,
    avatarUrl = data.avatarUrl,
    fullName = data.fullName,
    type = data.type,
    label = data.label;
  if (__isNew__) {
    return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, props);
  }
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, props, avatarUrl && /*#__PURE__*/_react["default"].createElement(StyledOptionAvatar, {
    src: avatarUrl
  }), /*#__PURE__*/_react["default"].createElement(StyledRow, null, /*#__PURE__*/_react["default"].createElement(StyledOptionName, null, fullName || 'Без имени'), /*#__PURE__*/_react["default"].createElement(StyledOptionDescription, null, type === 'client' ? 'Клиент Level.Travel' : 'Менеджер Level.Travel')), /*#__PURE__*/_react["default"].createElement(StyledOptionEmail, null, label));
};
var LoadingMessage = function LoadingMessage(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledLoadingContainer, props, /*#__PURE__*/_react["default"].createElement(StyledSpinner, {
    color: "#007aff"
  }));
};
var ContainerStyle = function ContainerStyle(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'static'
  });
};
var MenuStyle = function MenuStyle(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    zIndex: 1000,
    padding: 0,
    margin: 0
  });
};
var MenuListStyle = function MenuListStyle(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    width: '100%',
    maxHeight: '150px',
    padding: 0,
    margin: 0,
    whiteSpace: 'pre-line',
    color: '#17181a',
    borderRadius: '4px',
    backgroundColor: 'white',
    boxShadow: '0 10px 15px 0 rgba(196, 194, 182, 0.9), 0 1px 2px 0 rgba(210, 208, 197, 0.9)'
  });
};
var OptionStyle = function OptionStyle(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#dcedff'
    }
  });
};
var SingleValueStyle = function SingleValueStyle(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    backgroundColor: state.isDisabled ? '#e6e6e6' : 'white',
    border: '1px solid #C2C5CC',
    boxSizing: 'border-box',
    borderRadius: '40px',
    minWidth: 'auto',
    padding: '3px 6px',
    lineHeight: '16px',
    fontSize: '14px',
    color: '#4D4D4D'
  });
};
var MultiValueStyle = function MultiValueStyle(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    backgroundColor: state.isDisabled ? '#e6e6e6' : 'white',
    border: '1px solid #C2C5CC',
    boxSizing: 'border-box',
    borderRadius: '40px',
    minWidth: 'auto'
  });
};
var MultiValueLabelStyle = function MultiValueLabelStyle(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    fontFamily: 'Backpack, sans-serif',
    fontSize: '14px',
    lineHeight: '16px',
    overflow: 'initial',
    textOverflow: 'unset',
    color: '#4D4D4D'
  });
};
var MultiValueRemoveStyle = function MultiValueRemoveStyle(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    '&:hover': {
      background: 'transparent'
    },
    svg: {
      fill: '#919499',
      marginTop: '1px'
    }
  });
};
var UserSelect = /*#__PURE__*/_react["default"].memo(function (_ref2) {
  var options = _ref2.options,
    value = _ref2.value,
    onChange = _ref2.onChange,
    onInputChange = _ref2.onInputChange,
    isMulti = _ref2.isMulti,
    isDisabled = _ref2.isDisabled,
    isLoading = _ref2.isLoading,
    isCreatable = _ref2.isCreatable,
    isBordered = _ref2.isBordered,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var ControlStyle = function ControlStyle(base) {
    return _objectSpread(_objectSpread({
      backgroundColor: isBordered ? '1px solid red' : 'transparent'
    }, base), {}, {
      border: isBordered ? '1px solid red' : 'none',
      boxShadow: 'none',
      '&:hover': {
        border: 'none'
      },
      '.react-select__value-container': {
        overflow: 'auto',
        flexWrap: 'nowrap'
      }
    });
  };
  return isCreatable ? /*#__PURE__*/_react["default"].createElement(StyledCreatableSelect, (0, _extends2["default"])({
    type: "text",
    isMulti: isMulti,
    isDisabled: isDisabled,
    isClearable: false,
    placeholder: "Email",
    isLoading: isLoading,
    noOptionsMessage: function noOptionsMessage() {
      return 'Введите email или имя';
    },
    classNamePrefix: "react-select",
    filterOption: function filterOption() {
      return true;
    },
    options: options,
    value: value,
    onChange: onChange,
    onInputChange: onInputChange,
    formatCreateLabel: function formatCreateLabel(userInput) {
      return "C\u043E\u0437\u0434\u0430\u0442\u044C ".concat(userInput);
    },
    styles: {
      container: ContainerStyle,
      menu: MenuStyle,
      menuList: MenuListStyle,
      option: OptionStyle,
      control: ControlStyle,
      multiValue: MultiValueStyle,
      singleValue: SingleValueStyle,
      multiValueLabel: MultiValueLabelStyle,
      multiValueRemove: MultiValueRemoveStyle
    },
    components: {
      MenuList: MenuList,
      Option: Option,
      LoadingMessage: LoadingMessage
    }
  }, props)) : /*#__PURE__*/_react["default"].createElement(StyledSelect, (0, _extends2["default"])({
    type: "text",
    isMulti: isMulti,
    isDisabled: isDisabled,
    isClearable: false,
    placeholder: "Email",
    noOptionsMessage: function noOptionsMessage() {
      return 'Список email-ов недоступен, обратитесь в поддержку';
    },
    isLoading: isLoading,
    classNamePrefix: "react-select",
    options: options,
    value: value,
    onChange: onChange,
    onInputChange: onInputChange,
    styles: {
      container: ContainerStyle,
      menu: MenuStyle,
      menuList: MenuListStyle,
      option: OptionStyle,
      control: ControlStyle,
      multiValue: MultiValueStyle,
      singleValue: SingleValueStyle,
      multiValueLabel: MultiValueLabelStyle,
      multiValueRemove: MultiValueRemoveStyle
    },
    components: {
      MenuList: MenuList,
      Option: Option,
      LoadingMessage: LoadingMessage
    }
  }, props));
});
UserSelect.displayName = 'UserSelect';
var OptionType = exports.OptionType = _propTypes["default"].shape({
  value: _propTypes["default"].string,
  label: _propTypes["default"].string,
  type: _propTypes["default"].string,
  fullName: _propTypes["default"].string,
  email: _propTypes["default"].string
});
var ValueType = exports.ValueType = _propTypes["default"].shape({
  value: _propTypes["default"].any,
  label: _propTypes["default"].string
});
MenuList.propTypes = {
  children: _propTypes["default"].node.isRequired
};
UserSelect.propTypes = {
  value: _propTypes["default"].arrayOf(ValueType),
  defaultValue: _propTypes["default"].arrayOf(ValueType),
  onChange: _propTypes["default"].func,
  options: _propTypes["default"].arrayOf(OptionType),
  isMulti: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  isCreatable: _propTypes["default"].bool
};
UserSelect.defaultProps = {
  value: null,
  options: null,
  onChange: Function.prototype,
  isMulti: true,
  isDisabled: false,
  isLoading: false,
  isCreatable: true
};
var StyledCreatableSelect = (0, _styledComponents["default"])(_creatable["default"]).withConfig({
  displayName: "UserSelect__StyledCreatableSelect",
  componentId: "sc-vd2k0g-0"
})(["border:none;outline:none;display:block;padding:0;width:100%;"]);
var StyledSelect = (0, _styledComponents["default"])(_reactSelect["default"]).withConfig({
  displayName: "UserSelect__StyledSelect",
  componentId: "sc-vd2k0g-1"
})(["border:none;outline:none;display:block;padding:0;width:100%;"]);
var StyledRow = _styledComponents["default"].div.withConfig({
  displayName: "UserSelect__StyledRow",
  componentId: "sc-vd2k0g-2"
})(["display:flex;"]);
var StyledOptionAvatar = _styledComponents["default"].img.withConfig({
  displayName: "UserSelect__StyledOptionAvatar",
  componentId: "sc-vd2k0g-3"
})(["float:left;margin-right:10px;width:26px;height:26px;border-radius:100%;"]);
var StyledOptionName = _styledComponents["default"].p.withConfig({
  displayName: "UserSelect__StyledOptionName",
  componentId: "sc-vd2k0g-4"
})(["display:flex;align-items:center;font-size:14px;font-weight:bold;margin-right:5px;&::after{content:' ';width:3px;height:3px;margin-top:4px;margin-left:5px;background-color:#17181a;border-radius:100%;}"]);
var StyledOptionDescription = _styledComponents["default"].p.withConfig({
  displayName: "UserSelect__StyledOptionDescription",
  componentId: "sc-vd2k0g-5"
})(["margin-top:1px;font-size:12px;"]);
var StyledOptionEmail = _styledComponents["default"].p.withConfig({
  displayName: "UserSelect__StyledOptionEmail",
  componentId: "sc-vd2k0g-6"
})(["font-size:12px;"]);
var StyledLoadingContainer = _styledComponents["default"].div.withConfig({
  displayName: "UserSelect__StyledLoadingContainer",
  componentId: "sc-vd2k0g-7"
})(["height:50px;display:flex;align-items:center;justify-content:center;"]);
var StyledSpinner = (0, _styledComponents["default"])(_Throbber["default"]).withConfig({
  displayName: "UserSelect__StyledSpinner",
  componentId: "sc-vd2k0g-8"
})(["height:20px;width:20px;position:relative;margin:0;left:0;display:inline-block;::before{width:20px;height:20px;bottom:0;top:-1px;position:absolute;}"]);
var _default = exports["default"] = UserSelect;